import { render, staticRenderFns } from "./StudyCourse.vue?vue&type=template&id=7f923505&scoped=true"
import script from "./StudyCourse.vue?vue&type=script&lang=js"
export * from "./StudyCourse.vue?vue&type=script&lang=js"
import style0 from "./StudyCourse.vue?vue&type=style&index=0&id=7f923505&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f923505",
  null
  
)

export default component.exports